const getters = {
    allNotifications: (state) => state.allNotifications,
    newNotifications: (state) => state.newNotifications,
    displayedNotifications: (state) => state.displayedNotifications,
    historyNotifications: (state) => state.historyNotifications,
    isRequesting: (state) => state.isRequesting,

}
export default getters
